import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getSettings,
  updateSettings,
  updateRole,
} from "../../api/hub/identity";
import { hubKeys } from "../../api/hub/client";
import type { Role } from "../../api/hub/types";
export function usePlatformSettings() {
  const qc = useQueryClient();
  return {
    settings: useQuery({ queryKey: hubKeys.settings, queryFn: getSettings }),
    save: useMutation({
      mutationFn: updateSettings,
      onSuccess: () => qc.invalidateQueries({ queryKey: hubKeys.settings }),
    }),
    role: useMutation({
      mutationFn: ({ id, role }: { id: string; role: Role }) =>
        updateRole(id, role),
      onSuccess: () => qc.invalidateQueries({ queryKey: hubKeys.people }),
    }),
  };
}
